import { memo } from 'react';
import _ from 'lodash';
import ContentLoader from 'react-content-loader';
import ProfileStore from '../stores/ProfileStore';

import { Trans, useTranslation } from 'react-i18next';
import { ReactComponent as InstalmentIcon } from '@/img/icons/bnpl-instalments.svg';

const InstallmentsBanner = ({ isLoading, isRtl, text }) => {
    const { t } = useTranslation();
    const profile = ProfileStore.getProfile();

    const company_installments_iframe_enabled = _.get(profile, 'company.settings.installments_iframe_enabled', false);

    if (!company_installments_iframe_enabled) {
        return null;
    }

    if (isLoading) {
        return (
            <div>
                <ContentLoader width="770px" height="48px" rtl={isRtl}>
                    <rect x="0" y="0" rx="8" ry="8" width="770px" height="48px" />
                </ContentLoader>
            </div>
        );
    }

    return (
        <div className="installments-banner">
            <div className="installments-banner__text">
                {text || (
                    <Trans i18nKey="HotelPage.BnplInstalmentsBannerVariant1" values={{ installments_max_num: 3 }} />
                )}
            </div>

            <div className="installments-banner__icon-wrap">
                <InstalmentIcon />
            </div>
        </div>
    );
};

export default memo(InstallmentsBanner);
